let privateMethods = {};
privateMethods.testfunction = function testfunction(){
      console.log('Hello');
  };

privateMethods.removeNode = function removeNode(node) {
  const parent = node.parentNode;
  if (parent) {
    parent.removeChild(node);
  }
  
}

privateMethods.createToolTipId = function _createToolTipId() {
  function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
  }
  return ['tooltip', s4() + s4(), s4(), s4(), s4(), s4() + s4() + s4()].join('-');
};
privateMethods._tooltips = [];
privateMethods.addTooltip = function addTooltip(tooltip) {
  privateMethods._tooltips.push(tooltip);
};
privateMethods.closeOthers = function closeOthers(tooltip) {
      privateMethods._tooltips.forEach((t, x) => {
          if(privateMethods._tooltips[x].id !== tooltip.id) {
              privateMethods._tooltips[x].close();
          }
      });
};
privateMethods.datareturntooltipid = function datareturntooltipid() {
    let lastId = 0;
    let store = {};
    return {
        set(element, info) {
            let id = 0;
            if (element.tooltipid === undefined) {
                id = lastId++;
                element.tooltipid = id;
            }
            store[id] = info;
        },
        get(element) {
           return store[element.tooltipid];
        }
    };
};
privateMethods.datareturncontent = function datareturncontent() {
    let lastId = 0;
    let store = {};
    return {
        set(element, info) {
            let id = 0;
            if (element.content === undefined) {
                id = lastId++;
                element.content = id;
            }
            store[id] = info;
        },
        get(element) {
           return store[element.content];
        }
    };
};
privateMethods.datareturntooltip = function datareturntooltip() {
    let lastId = 0;
    let store = {};
    return {
        set(element, info) {
            let id = 0;
            if (element.ToolTip === undefined) {
                id = lastId++;
                element.ToolTip = id;
            }
            store[id] = info;
        },
        get(element) {
           return store[element.ToolTip];
        }
    };
};
privateMethods.extend = function extend(out={}) {
    for (let i = 1; i < arguments.length; i++) {
if (!arguments[i])
continue;
for (const key in arguments[i]) {
  if (arguments[i].hasOwnProperty(key))
  out[key] = arguments[i][key];
}
}
    return out;
};
privateMethods.testf = function testf() {
  console.log(privateMethods.createToolTipId());
};
let mainid = '';
let position = '';

module.exports = {
	privateMethods,
	mainid,
	position
}



//////////////////
// WEBPACK FOOTER
// /Users/pxm847m/git/global-tooltip/source/js/modules/helpers.js
// module id = 1
// module chunks = 0